'use client';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { BILLING_PLAN_LIMIT_FIELDS } from '@/constants/billing.constant';
function limitTitle(key) {
  if (!key) return 'plan limit';
  return BILLING_PLAN_LIMIT_FIELDS.find(f => f.name === key)?.title ?? key;
}
export const PlanLimitReachedDialog = ({
  open,
  limitKey,
  canManageBilling = false,
  contractBilling = false,
  canUpgrade = true,
  upgradeLoading = false,
  onUpgrade,
  onDismiss
}) => {
  const title = limitTitle(limitKey);
  const supportingCopy = (() => {
    if (contractBilling) {
      return ' Contact your account manager to increase capacity.';
    }
    if (canManageBilling) {
      return ' Upgrade your plan or request more capacity to continue.';
    }
    return ' Contact your Admin or Support to increase capacity.';
  })();
  const showBillingCta = canManageBilling && !contractBilling;
  const primaryLabel = canUpgrade ? 'Upgrade plan' : 'Manage billing';
  return <Dialog open={open} onClose={onDismiss} maxWidth="xs" fullWidth PaperProps={{
    sx: {
      borderRadius: '8px'
    }
  }}>
            <DialogTitle sx={{
      fontWeight: 600
    }}>Plan limit reached</DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary">
                    You&apos;ve reached <strong>{title}</strong> on your current plan.
                    {supportingCopy}
                </Typography>
            </DialogContent>
            <DialogActions sx={{
      px: 3,
      pb: 3,
      gap: 1.5
    }}>
                {showBillingCta ? <>
                        <Button onClick={onDismiss} color="neutral" variant="contained" disabled={upgradeLoading} fullWidth>
                            Not now
                        </Button>
                        <Button variant="contained" disableElevation onClick={onUpgrade} disabled={upgradeLoading} fullWidth>
                            {upgradeLoading ? 'Opening…' : primaryLabel}
                        </Button>
                    </> : <Button variant="contained" disableElevation onClick={onDismiss} fullWidth>
                        Got it
                    </Button>}
            </DialogActions>
        </Dialog>;
};